var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "700px" },
      on: {
        "click:outside": function ($event) {
          return _vm.$emit("close-group-users-dialog")
        },
      },
      model: {
        value: _vm.dialogDisplayUsers,
        callback: function ($$v) {
          _vm.dialogDisplayUsers = $$v
        },
        expression: "dialogDisplayUsers",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "rounded-t-0" },
        [
          _c(
            "v-card-title",
            {
              staticClass: "headline mitreSecondaryBlue",
              attrs: { "data-cy": "groupModalTitle", "primary-title": "" },
            },
            [_vm._v(" " + _vm._s(_vm.role) + " ")]
          ),
          _c(
            "v-card-text",
            [
              _c("Users", {
                attrs: { editable: false },
                model: {
                  value: _vm.selectedGroupUsers,
                  callback: function ($$v) {
                    _vm.selectedGroupUsers = $$v
                  },
                  expression: "selectedGroupUsers",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c(
                "v-col",
                { staticClass: "text-right" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", text: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close-group-users-dialog")
                        },
                      },
                    },
                    [_vm._v(" Close ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }